import { render, staticRenderFns } from "./tree-picker.vue?vue&type=template&id=6a234d48&"
import script from "./tree-picker.vue?vue&type=script&lang=js&"
export * from "./tree-picker.vue?vue&type=script&lang=js&"
import style0 from "./tree-picker.vue?vue&type=style&index=0&id=6a234d48&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports